import { createFileRoute } from '@tanstack/react-router';
import { TeamPage } from '@/features/team/team-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/team')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/team');
  },
  component: TeamPage,
});
